<template>
  <div class="clearfix">
  <span v-if="registerErrorMsg" class="text-danger block my-6">{{ registerErrorMsg }}</span>
    <vs-input
      v-validate="'required|min:3|max:20'"
      data-vv-validate-on="blur"
      data-vv-as="First name"
      label="First Name"
      name="displayName"
      placeholder="Name"
      v-model="displayName"
      class="w-full" />
      <span class="text-danger my-2">{{ errors.first('displayName') }}</span>

      <div class="mt-5 mb-2">
        <label class="vs-input--label">Deal Code</label>
        <p class="max-w-sm text-lg mb-5">Enter your deal code under <span class="font-medium">"Billing & Plan"</span> to <span class="font-medium">upgrade</span> your 14-day trial to a  <span class="font-medium">lifetime plan!</span></p>
      </div>

    <vs-input
      v-validate="'required|email|max:60'"
      data-vv-validate-on="blur"
      name="email"
      type="email"
      label="Email"
      placeholder="Email"
      v-model="email"
      class="w-full mt-6" />
    <span class="text-danger text-sm">{{ errors.first('email') }}</span>


    <vs-input
      ref="password"
      type="password"
      data-vv-validate-on="blur"
      v-validate="'required|min:6|max:15'"
      name="password"
      label="Password"
      placeholder="Password"
      @blur="checkPWAlpha"
      v-model="password"
      class="w-full mt-6" />
      <span class="text-danger text-sm">{{ errors.first('password') ? errors.first('password') : passwordMsg }}</span>

    <vs-input
      type="password"
      v-validate="'min:6|max:15|confirmed:password'"
      data-vv-validate-on="blur"
      data-vv-as="password"
      name="confirm_password"
      label="Confirm Password"
      placeholder="Confirm Password"
      v-model="confirm_password"
      class="w-full mt-6" />
    <span class="text-danger text-sm">{{ errors.first('confirm_password') }}</span>


    <p class="mt-6">By continuing, you agree to the Feedback Link <a href="https://feedback.link/tos.html" target="_blank">terms of use.</a></p>
    <vs-checkbox v-model="isTermsConditionAccepted" class="mt-4">I accept the terms of use</vs-checkbox>
    <vs-button  type="flat" to="/pages/login" class="w-full my-4">< To Login</vs-button>
    <vs-button class="w-full mb-8" size="large" @click="registerUser" :disabled="!validateForm">Get started</vs-button>
  </div>
</template>

<script>

function isAlphaNumeric(myString) {
  return (/\d/.test(myString) && (myString.match(/[a-z]/i)))
}

export default {
  data () {
    return {
      registerErrorMsg: false,
      displayName: '',
      email: '',
      password: '',
      confirm_password: '',
      isTermsConditionAccepted: false,
      passwordMsg: '',      
    }
  },
  props: {
    provider: String
  },
  watch: {
    password() {
      this.passwordMsg = ''
    }
  },
  computed: {
    validateForm () {
      return this.passwordMsg === '' && !this.errors.any() && this.displayName !== '' && this.email !== '' && this.password !== '' && this.confirm_password !== '' && this.isTermsConditionAccepted === true
    }
  },
  methods: {
    checkPWAlpha () {
      if (this.password !== '') {
        if (!isAlphaNumeric(this.password)){
          this.passwordMsg = 'Password must contain at least one number and one letter.'
        }
      }
    },
    setErrorMessage (msg){
      this.registerErrorMsg = msg
    },
    registerUser () {
      // If form is not validated or user is already login return

      this.$vs.loading()

      this.registerErrorMsg = false

      if (!this.validateForm) return

      const payload = {
        userDetails: {
          displayName: this.displayName,
          email: this.email,
          password: this.password,
          LTDPartner: this.provider
        }
      }

      this.$store.dispatch('auth/registerUser', payload).then(() => {

        this.$vs.loading.close()
        this.$router.push('/dash/setup')

      }).catch((e) => {

      this.$vs.loading.close()
      //noconsoleconsole.log(e)
      this.$vs.dialog({
        type: 'confirm',
        color: 'dark',
        acceptText: 'Ok',
        cancelText: 'To Login',
        title: `Create account`,
        text: 'We couldn\'t create your account with that email address, are you sure you\'re not already signed up?',
        cancel: () => {
          this.$router.push('/dash/login')
        }
      })

      })

    }
  }
}
</script>
